var cov_zp176oa6e = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/styles/index.ts",
      hash = "e5380abace7af3e7867925dc55d940b84c6b13cb",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var treeLess = {};
import genaration from '../../utils/classname';
export var treeClass = (cov_zp176oa6e.s[0]++, genaration(treeLess, 'tree'));